import AiBotStatsAPI from 'dashboard/api/aiBot/stats';
import { throwErrorMessage } from '../../utils/api';

const types = {
  SET_UI_FLAG: 'SET_UI_FLAG',
  SET_STATS: 'SET_STATS',
};

export const state = {
  records: {},
  meta: { period: '7d' },
  uiFlags: {
    isFetching: false,
  },
};

export const getters = {
  getRecords: $state => $state.records,
  getUIFlags: $state => $state.uiFlags,
  getMeta: $state => $state.meta,
};

export const actions = {
  get: async ({ commit }, { botId, period }) => {
    commit(types.SET_UI_FLAG, { isFetching: true });
    try {
      const response = await new AiBotStatsAPI(botId).get({ period });
      commit(types.SET_STATS, { period, stats: response.data });
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_UI_FLAG, { isFetching: false });
    }
  },
};

export const mutations = {
  [types.SET_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  [types.SET_STATS]($state, { period, stats }) {
    $state.records = stats;
    $state.meta = { period };
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
